import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "react-i18next";


export function CommonDialog({visible,header,onOK,onCancel,onClose,children,onHide})
{
    const {t}=useTranslation();

   const renderFooter=()=>{
        return (
            <div>
                {onCancel?<Button label={t("Cancel")} icon="pi pi-times" onClick={onCancel} className="p-button-text" />:''}
                {onOK?<Button label={t("Ok")} icon="pi pi-check" onClick={onOK} autoFocus />:''}
                {onClose?<Button label={t("Close")} icon="pi pi-cross" onClick={onClose} autoFocus />:''}
            </div>
        );
    }	    
    return(
        <>
        <Dialog header={header} visible={visible} footer={renderFooter} onHide={onHide}>
            {children}
        </Dialog>
        </>
    );
}